import React, { useState } from "react"

import { DGText } from "../../../components/common/DGText"
import {
  Colors,
  GenericButton,
  GenericButtonProps,
} from "../../../components/common/GenericButton"
import { theme, TI } from "../../../utilities/theme"

export const OnboardingButton = ({
  textColors,
  backgroundColors,
  text,
  onBlur,
  shadow = true,
  ...rest
}: Omit<GenericButtonProps, "children"> & {
  text: string
  textColors?: Colors
}) => {
  const [focused, setFocused] = useState(false)
  return (
    <GenericButton
      {...rest}
      shadow={shadow}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        onBlur?.()
        setFocused(false)
      }}
      backgroundColors={
        backgroundColors ?? {
          focused: "rgba(255,255,255,1)",
          blurred: "rgba(48, 57, 73, 1)",
        }
      }
    >
      <DGText
        tx={TI.Subheadline07tv}
        sx={{
          color: focused
            ? (textColors?.focused ?? theme.palette.black.main)
            : (textColors?.blurred ?? theme.palette.white.main),
        }}
      >
        {text}
      </DGText>
    </GenericButton>
  )
}
